export default __webpack_public_path__ + "static/media/lines.b587e809.svg";